import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowUp } from "@fortawesome/pro-solid-svg-icons"
import { roundNumber } from "services/helpers"
import * as styles from "./DashboardDifference.module.css"

type DifferenceProps = {
  percentage?: number
  differenceIsPositive?: boolean
  label?: string
  showIcon?: boolean
  showGrey?: boolean
}

const Difference = ({
  showIcon,
  showGrey,
  percentage,
  label,
  differenceIsPositive = percentage !== undefined && percentage > 0,
}: DifferenceProps) => {
  const percentageNull =
    percentage === 0 || percentage === undefined || percentage === null
  return (
    <div className={styles.DifferenceWrapper}>
      <span className={styles.DifferenceLabel}>{label}</span>
      <span
        className={`${styles.DifferenceText} ${
          showGrey || percentageNull
            ? styles.grey
            : percentage > 0
            ? styles.positive
            : styles.negative
        }`}
      >
        {showIcon && typeof percentage === "number" && percentage !== 0 && (
          <FontAwesomeIcon
            className={styles.DifferenceIcon}
            icon={faArrowUp}
            rotation={differenceIsPositive ? undefined : 180} // Not a fan of se  tting undefined but thats what interface expects
          />
        )}
        {percentage !== undefined
          ? Math.abs(roundNumber(percentage)) + "%"
          : "0%"}
      </span>
    </div>
  )
}

export default Difference
